// src/entitlements/manifest.ts
var ENTITLEMENTS_MANIFEST = {
  anonymous: {
    features: {
      "feature:subscription_management": false,
      "feature:account_settings": false,
      "feature:retention_preference": false,
      "feature:delete_all_data": false,
      "feature:family_admin": false,
      "feature:practitioner_mode": false
    },
    limits: {
      // 24h — anon is throwaway browsing per C2A contract (PR #1130).
      "limit:retention_ms": 24 * 60 * 60 * 1e3,
      "limit:character_count": 500,
      // Anonymous tier uses a WEEKLY window (10/week, not 10/day). The
      // manifest stores the numeric ceiling here; the quota window itself is
      // tracked separately in `EntitlementsDto.quotaPolicy.window`.
      "limit:daily_quota": 10,
      "limit:family_members": 0
    }
  },
  free: {
    features: {
      "feature:subscription_management": true,
      "feature:account_settings": true,
      "feature:retention_preference": true,
      "feature:delete_all_data": true,
      "feature:family_admin": false,
      "feature:practitioner_mode": false
    },
    limits: {
      // 7d — sign-up reward per C2A contract (PR #1130).
      "limit:retention_ms": 7 * 24 * 60 * 60 * 1e3,
      "limit:character_count": 1e3,
      "limit:daily_quota": 10,
      "limit:family_members": 0
    }
  },
  drama_plus: {
    features: {
      "feature:subscription_management": true,
      "feature:account_settings": true,
      "feature:retention_preference": true,
      "feature:delete_all_data": true,
      "feature:family_admin": true,
      "feature:practitioner_mode": true
    },
    limits: {
      "limit:retention_ms": 180 * 24 * 60 * 60 * 1e3,
      // 180 days
      "limit:character_count": 2e3,
      "limit:daily_quota": 100,
      // 4 family members. Source of truth for current limit lives in
      // family-plan provisioning (see `polar-webhook/family-plan-sync.ts`).
      "limit:family_members": 4
    }
  },
  dramax: {
    features: {
      "feature:subscription_management": true,
      "feature:account_settings": true,
      "feature:retention_preference": true,
      "feature:delete_all_data": true,
      "feature:family_admin": true,
      "feature:practitioner_mode": true
    },
    limits: {
      "limit:retention_ms": 365 * 24 * 60 * 60 * 1e3,
      // 365 days
      "limit:character_count": 5e3,
      "limit:daily_quota": 200,
      // TODO: verify against family-plan-sync — current code allows up to
      // 8 members for DramaX family plans; confirm with product before C3B.
      "limit:family_members": 8
    }
  }
};
function hasFeatureBoolean(tier, feature) {
  const value = ENTITLEMENTS_MANIFEST[tier].features[feature];
  return typeof value === "boolean" ? value : false;
}
function getFeatureValue(tier, feature) {
  return ENTITLEMENTS_MANIFEST[tier].features[feature];
}
function getLimit(tier, limit) {
  return ENTITLEMENTS_MANIFEST[tier].limits[limit] ?? 0;
}

export {
  ENTITLEMENTS_MANIFEST,
  hasFeatureBoolean,
  getFeatureValue,
  getLimit
};
